.sortableItemBorder {
  border: 2px solid #ced4da;
  border-radius: 8px;
  background-color: var(--bs-body-bg);
}

.sortableItemGripHolder {
  width: 16px;
  align-self: center;
  cursor: grab;
  transition: max-height 0.5s ease-in-out;
  overflow: hidden;
}

.sortableItemAfterGrip {
  width: calc(100% - 16px);
  flex-grow: 1;
}
